module.exports = __webpack_public_path__ + "img/cr.b6d92c95.svg";